module.exports = __webpack_public_path__ + "static/media/ManeLogo.84052bd9.svg";